import $ from 'jquery';
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui/ui/i18n/datepicker-it";
import "jquery-ui/ui/i18n/datepicker-en-GB";
import "jquery-ui/ui/i18n/datepicker-de";

export default () => {
    if ($("body.home").length > 0 || $(".camera-template-default").length > 0 || $(".post-template-default").length > 0 ) {

        var language = ICL_LANGUAGE_CODE == 'en' ? 1 : (
            ICL_LANGUAGE_CODE == 'it' ? 2 : (
                ICL_LANGUAGE_CODE == 'de' ? 3 : 1
            )
        );

        var dateformat = ICL_LANGUAGE_CODE == 'en' ? 'mm/dd/yy' : (
            ICL_LANGUAGE_CODE == 'it' ? 'dd/mm/yy' : (
                ICL_LANGUAGE_CODE == 'de' ? 'dd/mm/yy' : 'mm/dd/yy'
            )
        );

        $('.date-input-field').datepicker({
            dateFormat: dateformat,
            firstDay: 1,
            minDate: new Date(2019, 11 - 1, 29),
        });
        $.datepicker.setDefaults($.datepicker.regional[window.ICL_LANGUAGE_CODE]);

        var datefrom = $('#datestart').datepicker()
                .on('change', function () {
                    console.log(getDate(this, dateformat));
                    dateto.datepicker('option', 'minDate', getDate(this, dateformat));
                }),
            dateto = $('#dateend').datepicker()
                .on('change', function () {
                    console.log(getDate(this, dateformat));
                    datefrom.datepicker('option', 'maxDate', getDate(this, dateformat));
                });


    }

    function getDate(element, dateFormat) {
        var date;
        try {
            date = $.datepicker.parseDate(dateFormat, element.value);
        } catch (error) {
            date = null;
        }

        return date;
    }
};



// WEBPACK FOOTER //
// ./scripts/libs/datepicker.js